import validate from "/usr/src/app/content/n3-spas-15c73afc-f6be-47b8-8ae2-b355b5846c7c/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-15c73afc-f6be-47b8-8ae2-b355b5846c7c/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}